<div class="px-2 d-none d-sm-block garage-box-wrap" [ngClass]="themeClass('garage-box-section1')"
  [class.g-width]="chTheme2 && isWishlist">
  <p class="m-0 pb-1 garage-line">My Garage</p>
  <span class="d-flex align-items-center  garage-bdr pt-1">
    <ng-container *ngIf="!vehicleName || chTheme3; else hasvehicleName">
      <ng-container *ngIf="!username; else hasloggedIn">
        <span class="model-heading mt-1 mb-2 cursor-pointer" (click)="goToLogin()">Login</span>
        <ng-container *ngIf="isSearchByVehicleDisabled && !chTheme3">
          <p class="model-heading sepreator mt-1 mb-2">|</p><span class="model-heading mt-1 mb-2 cursor-pointer"
            (click)="openVechicleSearchPopup()">Shop By Vehicle</span>
        </ng-container>
      </ng-container>
      <ng-template #hasloggedIn>
        <div (mouseenter)="showTooltip()" (mouseleave)="hideTooltip()"
          class="model-heading mt-1 mb-2 cursor-pointer tooltip-wrapper"> <div [routerLink]="['/my-account']"><span >Welcome,</span>
            <span class="user-n ms-1">{{ username }}</span></div>
          <div class="username-tooltip-down" *ngIf="tooltipVisible && username">
            <div class="tooltip-arrow-down"></div>
            <div class="tooltip-content" [routerLink]="['/logout']">
              <span class="greeting">Sign Out</span>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>
    <ng-template #hasvehicleName>
      <!-- <img [src]="commonImagePath +'cross.webp'" alt="cross-icon" class="me-1 mb-1 cross-icon cursor-pointer" width="20"
              height="20" (click)="clearVehicle()" /> -->    
      <span class="model-heading text-w mt-1 mb-1">{{ vehicleName }}</span>
       <div class="cross-icon-wrapper">
        <i class="fa-solid fa-xmark cross-icon cursor-pointer" (click)="clearVehicle()"></i>
      </div>
    </ng-template>
  </span>
</div>